import { ObjectSelectInputV2, ObjectSelectV2Props } from '@frontend/form';
import { WorkflowClient } from '@frontend/workflow/api';
import { Workflow, WorkflowQueryParams } from '@frontend/workflow/types';
import React, { useState } from 'react';

const ID = 'workflow-select';
export interface WorkflowSelectProps extends ObjectSelectV2Props<Workflow, WorkflowQueryParams> {}
/**
* @deprecated
*/
export const WorkflowSelect = (props: WorkflowSelectProps) => {
    const [v, cV] = useState<Workflow | null>(null);
    return (
        <ObjectSelectInputV2<Workflow, WorkflowQueryParams>
            {...props}
            id={`${ID}${props.id && '-' + props.id}`}
            label={props.label || 'Workflow'}
            onChange={(v) => {
                props.onChange && props.onChange(v?.id || null);
                cV(v);
            }}
            required={props.required}
            className={props.className}
            queryParams={props.queryParams}
            value={v}
            idValue={props.value || v?.id}
            fetch={(props) => WorkflowClient.fetchWorkflows(props)}
            itemLabel={(account) => account.name}
            isClearable={props.isClearable}
            disableFetch={props.disableFetch}
            disabled={props.disabled}
        />
    );
};
